import React, { useMemo } from 'react';
import { Button, Checkbox, Form, Input, Switch } from 'antd';
import { PrinterFormValues, PrinterItem } from '../../types';
import ErrorBoundary from '~/App/components/ErrorBoundary';
import { convertFromFormValues, convertToFormValues } from '../../utils';
import CategoryField from './CategoryField';

const rules = [
  {
    required: true,
    message: 'Please input this field',
  },
];

const PrinterForm = ({
  initialValues,
  loading,
  onSubmit,
}: {
  initialValues?: PrinterItem;
  loading: boolean;
  onSubmit: (values: PrinterItem) => void;
}) => {
  const initialFormValues = useMemo(() => {
    return {
      isActive: true,
      ...(initialValues ? convertToFormValues(initialValues) : {}),
    };
  }, [initialValues]);

  const onFinish = (values: PrinterFormValues) => {
    return onSubmit(convertFromFormValues(values));
  };

  return (
    <Form
      initialValues={initialFormValues}
      onFinish={onFinish}
      layout="vertical"
    >
      <Form.Item name="name" label="Name" rules={rules}>
        <Input placeholder="Name" />
      </Form.Item>
      <Form.Item name="ipAddress" label="IP address" rules={rules}>
        <Input placeholder="Ex: 192.168.0.10:9100" />
      </Form.Item>
      <Form.Item name="categories" label="Kategori & Tipe Order" rules={rules}>
        <Checkbox.Group>
          <ErrorBoundary>
            <CategoryField />
          </ErrorBoundary>
        </Checkbox.Group>
      </Form.Item>
      <Form.Item name="isActive" label="Active" valuePropName="checked">
        <Switch />
      </Form.Item>

      <Button
        htmlType="submit"
        type="primary"
        loading={loading}
        className="mt-6"
      >
        Submit
      </Button>
    </Form>
  );
};

export default PrinterForm;
